const { fetchAuthenticatedContent } = require("@parallelpublicworks/understory-auth");

module.exports = function saveBookmark(dispatch, user, id, type, bookmarked) {
	let bookmarks = user.relationships?.field_bookmarks?.data || [];
	if (!bookmarked) {
		bookmarks = [
			...bookmarks,
			{
				type,
				id,
			},
		];
	} else {
		bookmarks = [...bookmarks.filter((item) => item.id != id)];
	}
	let data = {
		type: "user--user",
		id: user.id,
		relationships: { field_bookmarks: { data: [...bookmarks] } },
	};
	return fetchAuthenticatedContent(dispatch, `user/user/${user.id}`, "PATCH", {
		data,
	});
};
